import React from 'react';
import UserList from '../Common/UserList';

const UserDirectory = ({ hideUserDirView }) => {
    return (
        <div id="userDirectory" className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ width: "60%", height: "90%", padding: "0" }}>
                <div className="modal-header align-center mt-2 mb-2">
                    <h5 style={{ marginLeft: "5px", padding: "5px" }}>#mfimovers - Directory</h5>
                    <span style={{ color: "black", marginRight: "0.3rem" }} className="close" onClick={hideUserDirView}>&times;</span>
                </div>
                <UserList fullAllow={0}></UserList>
            </div>
        </div>
    );
};

export default UserDirectory;